var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"holder"},[_c('img',{staticClass:"loader",attrs:{"src":require("@/assets/loader/loader.svg"),"alt":"loader"}}),_c('span',[_vm._v(_vm._s(_vm.$t("global.loading")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }